import "./index.scss";
import { activateEnquiry } from "./enquirybirthday";
let spanIndex = 0;
let servicesTitle = [
  "Fun Play Area",
  "Beautiful Party Set up",
  "Yummy Food",
  "Stress Free celebration...",
];

if ("scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

const hamburger = document.getElementById("hamburger");
const menu = document.getElementById("mobileMenu");

hamburger.addEventListener("click", () => {
  menu.classList.toggle("active");
});

document.addEventListener("click", (e) => {
  if (!menu.contains(e.target) && !hamburger.contains(e.target)) {
    menu.classList.remove("active");
  }
});

document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener("click", function (e) {
    e.preventDefault();

    const target = document.querySelector(this.getAttribute("href"));
    const offset = 80; // header height

    window.scrollTo({
      top: target.offsetTop - offset,
      behavior: "smooth",
    });
  });
});

const menuLinks = document.querySelectorAll(".mobile-menu a");

menuLinks.forEach((link) => {
  link.addEventListener("click", () => {
    menu.classList.remove("active");
  });
});

window.addEventListener("load", () => {
  window.scrollTo(0, 0);
  document.querySelector(".hero-content h1 span")?.classList.add("active");
  document
    .querySelector(".hero-content .sub-text span")
    ?.classList.add("active");
});
let ticking = false;

window.addEventListener("scroll", () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const elements = document.querySelectorAll("[data-animate]");

      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();

        if (
          rect.top <= window.innerHeight * 1.2 &&
          !el.classList.contains("active")
        ) {
          el.classList.add("active");
        }
      });

      ticking = false;
    });

    ticking = true;
  }
});

let imgticking = false;

function animateOnScroll() {
  const elements = document.querySelectorAll("[data-animate-img]");

  elements.forEach((el, index) => {
    const rect = el.getBoundingClientRect();

    if (
      rect.top <= window.innerHeight * 0.9 &&
      !el.classList.contains("active")
    ) {
      // find siblings in same parent
      const siblings = Array.from(
        el.parentElement.querySelectorAll("[data-animate-img]"),
      );

      siblings.forEach((img, i) => {
        if (!img.classList.contains("active")) {
          setTimeout(() => {
            img.classList.add("active");
          }, i * 150); // stagger
        }
      });
    }
  });

  imgticking = false;
}

window.addEventListener("scroll", () => {
  if (!imgticking) {
    window.requestAnimationFrame(animateOnScroll);
    imgticking = true;
  }
});

window.addEventListener("load", animateOnScroll);

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".picker-wrapper").forEach((field) => {
    const fakeinput = field.querySelector(".fake-input-date");
    const realinput = field.querySelector(".real-input-date");

    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isIOS || isSafari) {
      document.querySelectorAll(".fake-input-date").forEach((el) => {
        el.style.pointerEvents = "none";
      });
    }

    fakeinput?.addEventListener("click", () => {
      if (!isIOS && typeof realinput.showPicker === "function") {
        realinput.showPicker();
      }
    });
    realinput?.addEventListener("change", () => {
      const date = new Date(realinput.value);

      const formatted = date.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      fakeinput.value = formatted;

      if (!isIOS && isSafari) {
        requestAnimationFrame(() => {
          realinput.blur();
        });
      }
    });
  });

  activateEnquiry("PlayOClock BirthdayParty");

  document
    .querySelector(".mail-floater a")
    .addEventListener("click", function (e) {
      e.preventDefault();

      const target = document.querySelector(".contact-section");

      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });

  (function () {
    const images = document.querySelectorAll(".image-slider img");
    let current = 0;

    setInterval(() => {
      images[current].classList.remove("active");

      current = (current + 1) % images.length;

      images[current].classList.add("active");
    }, 2500);
  })();

  (function () {
    const scroll = document.querySelector(".top-scroll");
    const track = document.querySelector(".top-track");
    const SPEED = 1;

    let offset = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartOffset = 0;
    let setWidth = 0; // width of ONE original set

    function init() {
      const originals = Array.from(track.children);

      // Clone enough times to always fill viewport in both drag directions
      // 5 total sets (1 original + 4 clones) gives plenty of buffer
      const SETS = 5;
      for (let i = 0; i < SETS - 1; i++) {
        originals.forEach((el) => track.appendChild(el.cloneNode(true)));
      }

      // Measure one set
      const trackGap = parseFloat(getComputedStyle(track).gap) || 0;
      setWidth = originals.reduce(
        (acc, el) => acc + el.offsetWidth + trackGap,
        0,
      );

      // Start in the middle set so user can drag left without hitting empty space
      offset = setWidth * Math.floor(SETS / 2);

      requestAnimationFrame(tick);
    }

    function tick() {
      if (!isDragging) offset += SPEED;

      // Seamlessly wrap — always stay within [0, setWidth * SETS)
      // but visually it's infinite because we snap modulo setWidth
      offset = ((offset % setWidth) + setWidth) % setWidth;

      track.style.transform = `translateX(${-offset}px)`;
      requestAnimationFrame(tick);
    }

    scroll.addEventListener("mousedown", (e) => {
      isDragging = true;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      scroll.classList.add("dragging");
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      offset = dragStartOffset + (dragStartX - e.clientX);
    });

    window.addEventListener("mouseup", () => {
      isDragging = false;
      scroll.classList.remove("dragging");
    });

    scroll.addEventListener(
      "touchstart",
      (e) => {
        isDragging = true;
        dragStartX = e.touches[0].clientX;
        dragStartOffset = offset;
      },
      { passive: true },
    );

    scroll.addEventListener(
      "touchmove",
      (e) => {
        if (!isDragging) return;
        offset = dragStartOffset + (dragStartX - e.touches[0].clientX);
      },
      { passive: true },
    );

    scroll.addEventListener("touchend", () => {
      isDragging = false;
    });

    window.addEventListener("load", init);
  })();

  (function () {
    const container = document.querySelector(".food-img-container");
    const track = container?.querySelector(".food-top-strip");
    if (!container || !track) return;

    const SPEED = 0.2; // 👈 smooth speed

    let offset = 0;
    let isDragging = false;
    let dragStartX = 0;
    let dragStartOffset = 0;
    let setWidth = 0;

    function init() {
      const originals = Array.from(track.children);

      const SETS = 5;
      for (let i = 0; i < SETS - 1; i++) {
        originals.forEach((el) => track.appendChild(el.cloneNode(true)));
      }

      const gap = parseFloat(getComputedStyle(track).gap) || 0;

      setWidth = originals.reduce((acc, el) => acc + el.offsetWidth + gap, 0);

      offset = setWidth * Math.floor(SETS / 2);

      requestAnimationFrame(tick);
    }

    function tick() {
      if (!isDragging) offset += SPEED;

      offset = ((offset % setWidth) + setWidth) % setWidth;

      track.style.transform = `translateX(${-offset}px)`;

      requestAnimationFrame(tick);
    }

    // 🖱 Mouse drag
    container.addEventListener("mousedown", (e) => {
      isDragging = true;
      dragStartX = e.clientX;
      dragStartOffset = offset;
      container.classList.add("dragging");
    });

    window.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      offset = dragStartOffset + (dragStartX - e.clientX);
    });

    window.addEventListener("mouseup", () => {
      isDragging = false;
      container.classList.remove("dragging");
    });

    // 📱 Touch drag
    container.addEventListener(
      "touchstart",
      (e) => {
        isDragging = true;
        dragStartX = e.touches[0].clientX;
        dragStartOffset = offset;
      },
      { passive: true },
    );

    container.addEventListener(
      "touchmove",
      (e) => {
        if (!isDragging) return;
        offset = dragStartOffset + (dragStartX - e.touches[0].clientX);
      },
      { passive: true },
    );

    container.addEventListener("touchend", () => {
      isDragging = false;
    });

    // 👁 Start only when visible (optional but good)
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(container);

    window.addEventListener("load", init);
  })();
});

const popup = document.querySelector(".video-popup");
const iframe = popup.querySelector("iframe");

document.querySelectorAll(".video-btn").forEach((btn) => {
  btn.addEventListener("click", () => {
    iframe.src = btn.dataset.video;

    popup.classList.add("active");
  });
});

function closeVideo() {
  popup.classList.remove("active");

  iframe.src = "";
}

document.querySelector(".close-video").addEventListener("click", closeVideo);

document.querySelector(".video-overlay").addEventListener("click", closeVideo);

// window.addEventListener("DOMContentLoaded", animateBanner);

// function animateBanner() {
//   let spanIndex = 1;
//   setTimeout(() => {
//     document.querySelector(`.hero .sub-text .row`).classList.add("typewriter");
//     document.querySelector(`.hero .sub-text .row`).classList.add("white");
//     let lastTypeWidth = $(`.typewriter div`).width();
//     let resetCheck = true;
//     setInterval(() => {
//       if (lastTypeWidth < $(`.typewriter div`).width() && !resetCheck) {
//         if (spanIndex >= servicesTitle.length) {
//           spanIndex = 0;
//         }
//         $(`.typewriter div`).html(servicesTitle[spanIndex]);
//         spanIndex++;
//         resetCheck = true;
//       } else if (lastTypeWidth > $(`.typewriter div`).width()) {
//         resetCheck = false;
//       }
//       lastTypeWidth = $(`.typewriter div`).width();
//     }, 0);
//   }, 2000);
// }
